import React from 'react'
import { Link } from 'react-router-dom'

const Inicio = props => {
    return (
        <div>
            <div id='about'>                
                {/* Container (About Section) */}
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-sm-8'>
                            <h2>Sobre nós</h2><br />
                            <h4>Somos especializados em atender as principais áreas que permeiam a segurança privada. Com serviços para domicílios e corporações, oferecendo o mais alto nível de tecnologia em nossas soluções.</h4><br />
                            <h4>Contamos com um corpo técnico preparado para atender as necessidades particulares do seu negócio ou residência com soluções de segurança. Equipe tática especializada em ronda preventiva. Equipe de monitoramento 24 horas em contato com a polícia militar.</h4>
                            <br /><Link className='btn btn-default btn-lg' to='/contato'>Entre em contato</Link>                          
                        </div>
                        <div className='col-sm-4'>
                            <span className='glyphicon glyphicon-signal logo'></span>
                        </div>
                    </div>
                </div>

                <div className='container-fluid bg-grey'>
                    <div className='row'>
                        <div className='col-sm-4'>
                            <span className='glyphicon glyphicon-globe logo '></span>
                        </div>
                        <div className='col-sm-8'>
                            <h2>Nossos valores</h2><br />
                            <h4><strong>MISSÃO:</strong> Oferecer tranquilidade e segurança aos nossos clientes, para que possam executar suas atividades livremente, com a garantia do resguardo do seu lar.</h4><br />
                            <h4><strong>VISÃO:</strong> Ser o melhor prestador de serviços de segurança privada, oferecendo aos nossos clientes e parceiros uma relação duradoura, com foco na confiança e qualidade de vida por meio da tecnologia e segurança presencial.</h4>
                        </div>
                    </div>
                </div>
            </div>            
        </div>
    )
}

export default Inicio